import Track from "webPage/Track";
import { svg_include } from "base/functions";

export default function handleConsultantsSliderBlocks() {
    let $editorsSlider = $(".js-consultants-slider");
    if ($editorsSlider.length > 0) {
        $editorsSlider.each(function () {
            let $this = $(this);

            let track = new Track($this, {
                classes: {
                    block: "slider",
                },
            });

            if($this.find('.js-load-by-ajax').length > 0){
                const type = $this.attr('data-consultant-type');
                const random = $this.find('.js-load-by-ajax').data('random');
                const random_limit = $this.find('.js-load-by-ajax').data('random-limit');
                track.disable();

                let module = type ==='rehab-clinic' ? 'eotw-rehab-consultants' : 'eotw-consultants';

                Ajax.get(module, 'consultants/slider', {random, random_limit}).then((data) => {
                    if(data.success){
                        $this.find('.js-load-by-ajax').html(data.data.html);
                        track.enable();
                    } else {
                        $this.find('.js-load-by-ajax').html(eotwJSXFactory('div', {className: "no-results"}, [
                            eotwJSXFactory('div', {className: "icon", unsafeHtml: svg_include('no-results')}),
                            eotwJSXFactory('h2', {className: "heading heading--3"}, ["No consultants found"]),
                            eotwJSXFactory('p', null, ["Please try again"])
                        ]))
                    }
                }).catch((error) => {
                    $this.find('.js-load-by-ajax').html(eotwJSXFactory('div', {className: "no-results"}, [
                        eotwJSXFactory('div', {className: "icon", unsafeHtml: svg_include('no-results')}),
                        eotwJSXFactory('h2', {className: "heading heading--3"}, ["No consultants found"]),
                        eotwJSXFactory('p', null, ["Please try again"])
                    ]))
                    console.log(error);
                })
            }

            function checkSliderRequired() {
                let active = false;

                if ($(window).outerWidth() < 1280) {
                    track.$element.find('.js-slider-actions').hide();
                    track.enable();
                    return;
                }

                if(track.$element.outerWidth() < track.getTotalItemsSize()) {
                    active = true;
                }

                if(active) {
                    track.enable();
                    track.$element.find('.js-slider-actions').show();
                } else {
                    track.disable();
                    track.$element.find('.js-slider-actions').hide();
                }
            }

            $(window).on('resize', checkSliderRequired);
            checkSliderRequired();
        });
    }
}
